import { render } from "./HolidaysPage.vue?vue&type=template&id=6d01b599&scoped=true"
import script from "./HolidaysPage.vue?vue&type=script&lang=js"
export * from "./HolidaysPage.vue?vue&type=script&lang=js"

import "./HolidaysPage.vue?vue&type=style&index=0&id=6d01b599&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d01b599"]])

export default __exports__